import { useQuery } from "@tanstack/react-query";
import { backendService } from "../services/backend.service";

export const useAdminGuide = () => {
	return useQuery({
		queryKey: ["adminGuide"],
		queryFn: async () => {
			const response = await backendService.getAdminGuide();
			return response.data;
		},
	});
};
